<div id="transaction-details-section">
    <span id="subtitle">Standing authorization details</span>
    <a *ngIf="(createRequestStep$ | async) === 'review'  && !isInrFromTable" id="edit-link" class="no-print" (click)="onEditClicked()">Edit</a>
    <mm-label-group id="itDetails_transactionType" data-testid="itDetails_transactionType"
        [title]="labels.transactionType" [data]="transactionType"></mm-label-group>

    <div class="row" id="itDetails_receivingAccountRow">
        <div class="column">
            <mm-label-group id="itDetails_receivingAccount" data-testid="itDetails_receivingAccount"
                [title]="labels.receivingAccountNumber" [data]="info.toAccountInfo.accountNumber"></mm-label-group>
        </div>
        <div class="column">
            <mm-label-group id="itDetails_ReceivingAccountRegistration"
                data-testid="itDetails_ReceivingAccountRegistration" *ngIf="displayRegistration"
                [title]="labels.accountRegistration"
                [multilineData]="info.toAccountInfo.accountRegistration"></mm-label-group>
        </div>
    </div>

    <div *ngIf="info.iraFields.isIraTransaction">
        <mm-label-group id="itDetails_federaltax" data-testid="itDetails_federalTax" [title]="labels.federalTax"
            [data]="info.iraFields.fedTaxPercent"></mm-label-group>

        <mm-label-group id="itDetails_stateTax" data-testid="itDetails_stateTax"
            [title]="saStateTaxLabel" [data]="info.iraFields.stateTaxPercent"></mm-label-group>

        <div *ngIf="(createRequestStep$ | async) === 'review'" class="label-group">
            <span id="tax-copy-paragraph-one">{{taxCopyParagraphOne}}</span>
        </div>
    </div>

    <mm-label-group *ngIf="displayNickname" id="itDetails_authorizationNickname"
        data-testid="itDetails_authorizationNickname" [title]="labels.authorizationNickname"
        [data]="standingAuthDetails.authorizationNickname!"></mm-label-group>
</div>
<sdps-divider variation="secondary"></sdps-divider>
